module.exports = __webpack_public_path__ + "img/brainstorming.d58c60dd.png";